import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaBars, FaMinusCircle } from "react-icons/fa";
import { Tooltip } from "../../tooltip/index";
import { Checkbox } from "../../form/checkbox";
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
const DragHandle = SortableHandle(() => {
    return (React.createElement(InputBox, { className: "no-round width40 min40 flex-center cursor-move" },
        React.createElement("p", { className: "big font-bold" },
            React.createElement(FaBars, null))));
});
const SortableItem = SortableElement((props) => {
    const { itemIndex, change, remove, item } = props;
    return (React.createElement("div", { key: itemIndex, className: "flex-line", style: { alignItems: "flex-end" } },
        React.createElement(DragHandle, null),
        React.createElement(InputBox, { className: "no-round width64 min64 text-center" },
            React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, itemIndex + 1)),
        React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(Input, { type: "text", className: "no-round", style: { width: "220px" }, value: item !== undefined && item.name !== undefined ? item.name : "", onChange: (e) => change(itemIndex, "name", e.target.value) })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(Input, { type: "number", min: 0, step: 0.01, className: "no-round", style: { width: "100px" }, value: item !== undefined && item.fee !== undefined ? item.fee : "", onChange: (e) => change(itemIndex, "fee", e.target.value) })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputBox, { className: "no-round flex-center width75" },
                    React.createElement(Checkbox, { id: `${itemIndex}-disabled-fee`, checked: item !== undefined && item.disabled !== undefined ? item.disabled : false, onChange: (e) => change(itemIndex, "disabled", e.target.checked) })))),
        React.createElement(Tooltip, { text: "Delete", width: 65, position: "top" },
            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => remove(itemIndex) },
                React.createElement(FaMinusCircle, null)))));
});
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement("div", null, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, item: item, itemIndex: i, itemsLength: props.items.length, change: props.change, remove: props.remove })))));
});
export class FieldDeliveryZones extends React.Component {
    constructor(props) {
        super(props);
        this.change = (i, key, value) => {
            const values = [...this.props.values];
            values[i][key] = value;
            this.props.onChange(values);
        };
        this.onSortEnd = ({ oldIndex, newIndex }) => {
            const { onChange, values } = this.props;
            onChange(arrayMove(values, oldIndex, newIndex));
        };
        autobind(this);
    }
    remove(i) {
        const values = ([...this.props.values]);
        values.splice(i, 1);
        this.props.onChange(values);
    }
    render() {
        const { values, currencySymbol } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                React.createElement("div", { style: { width: "104px", minWidth: "104px" } }),
                React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                    React.createElement(FormGroup, { style: { width: "220px" }, className: "m-b-0", title: "Zone Name", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "100px" }, className: "m-b-0", title: `Cost (${currencySymbol || "$"})`, small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "75px" }, className: "m-b-0", title: "Disabled", small_title: true, no_border: true }))),
            React.createElement(SortableItemContainer, { helperClass: "zindex-100 bsl-2", pressDelay: 50, useDragHandle: true, items: values, change: this.change, remove: this.remove, onSortEnd: this.onSortEnd })));
    }
}
//# sourceMappingURL=index.js.map